import { isResponseError } from '@luna/api';

import type { SentryMiddleware } from './middlewareService';

export function createNoNetworkErrorsMiddleware(next: SentryMiddleware): SentryMiddleware {
    return (event, hint) => {
        if (isResponseError(hint.originalException)) {
            return null;
        }

        if (
            hint.originalException instanceof PromiseRejectionEvent &&
            isResponseError(hint.originalException.reason)
        ) {
            return null;
        }

        return next(event, hint);
    };
}
